import { render } from "./uploadLingerieExcelModal.vue?vue&type=template&id=c2a95f58&ts=true"
import script from "./uploadLingerieExcelModal.vue?vue&type=script&lang=ts"
export * from "./uploadLingerieExcelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__